import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as firebase from 'firebase';
import { DialogService } from 'src/app/shared/services/dialog.service';


class factura {
  id: string = '';
  razonSocial: string = '';
  nif: string = '';
  direccion: string = '';
  cp: string = '';
  pais: string = '';
  email: string = '';
  comentario: string = '';
  tlf: string = '';
  fechaGeneracion: Date = new Date;
  fechaPago: Date = new Date;
  total: number = 0;
  items: item[] = [];
}

class item {
  item: number = 0;
  descripcion: string = "";
  cantidad: number = 0;
  precioUnitario: number = 0;
  descuento: number = 0;
  total: number = 0; 
}

// 

export interface compra {
  cursoTitulo: string;
  cursoPrecioOriginal: number;
  cursoPorcentajeDescuento: number;
  cursoPrecioFinal: number;
  transaccionMoneda: string;
  transaccionTax: number;
  transaccionFecha: any;
  transaccionEstatusCobro: string;
  transaccionViaCobro: string;
  transaccionId: string;
  transaccionComentario: string;
  instructorNombre: string;
}

export interface datosFact {
  razonSocial: string;
  nif: string;
  direccion: string;
  cp: string;
  pais: string;
  email: string;
  tlf: string;
}


@Component({
  selector: 'app-detalle-factura',
  templateUrl: './detalle-factura.component.html',
  styleUrls: ['./detalle-factura.component.css']
})
export class DetalleFacturaComponent implements OnInit {

  // ofertaFecha = new Date;
  logo: string = "assets/images/logos/logo-p21-negro.png"
  id = this.route.snapshot.paramMap.get('id');
  uid = this.route.snapshot.paramMap.get('uid');

  usuario: any;
  compra: compra;
  datosFact: datosFact;
  loaded: number = 1;

  constructor(private router: Router,
    private storage: AngularFireStorage,
    private afs: AngularFirestore,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public dialogService: DialogService
    ) { }

  ngOnInit(): void {
    // this.cargarFactura()
    this.cargarCompras()
  }

  cargarCompras() {
    console.log(this.uid)
    this.afs.collection('usuariosCompras').doc(this.id).ref.get().then(doc => {
      const data = doc.data();
        const compra: compra = {
          cursoTitulo: data["cursoTitulo"],
          cursoPrecioOriginal: data["cursoPrecioFinal"],
          cursoPorcentajeDescuento: data["cursoPorcentajeDescuento"],
          cursoPrecioFinal: data["cursoPrecioFinal"],
          transaccionMoneda: data["transaccionMoneda"],
          transaccionTax: data["transaccionTax"],
          transaccionFecha: data["transaccionFecha"],
          transaccionEstatusCobro: data["transaccionEstatusCobro"],
          transaccionViaCobro: data["transaccionViaCobro"],
          transaccionId: data["transaccionId"],
          transaccionComentario: data["transaccionComentario"],
          instructorNombre: data["instructorNombre"],
        }
        this.compra = compra;
      this.cargarDatosFact();
    }).catch(error => {
    });
  }

  cargarDatosFact() {
    this.afs.collection('usuariosDatosFacturacion').doc(this.uid).ref.get().then(doc => {
      const datos = doc.data();
      this.datosFact = {
        razonSocial: datos['razonSocial'], //
        nif: datos['nif'],
        direccion: datos['direccion'],
        cp: datos['cp'],
        pais: datos['pais'],
        email: datos['email'], 
        tlf: datos['tlf'],
      }
    }).catch(error => {
      console.log(error)
    });
  }

}
